import { useTranslation } from 'react-i18next'
import { useUser } from '@/hooks/useUser'
import { ProfileCard } from '@/components/ProfileCard'

export function DashboardPage() {
  const { t } = useTranslation()
  const { data: user, isLoading, isError, error } = useUser()

  if (isLoading) {
    return (
      <div className="bg-background px-4 py-8">
        <div className="mx-auto mb-6 max-w-151.25">
          <h1 className="text-heading text-xl font-semibold">{t('profile.title')}</h1>
        </div>
        <div className="border-border bg-card mx-auto max-w-151.25 animate-pulse rounded-2xl border p-6">
          <div className="bg-placeholder mb-4 h-5 w-24 rounded" />
          <div className="flex gap-4">
            <div className="bg-placeholder h-18 w-18 shrink-0 rounded-full" />
            <div className="flex-1 space-y-2">
              <div className="bg-placeholder h-4 w-48 rounded" />
              <div className="bg-placeholder h-3 w-32 rounded" />
              <div className="bg-placeholder h-3 w-40 rounded" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (isError || !user) {
    return (
      <div className="bg-background px-4 py-8">
        <div className="mx-auto max-w-151.25">
          <h1 className="text-heading mb-6 text-xl font-semibold">{t('profile.title')}</h1>
          <p className="text-destructive">
            {error instanceof Error ? error.message : t('profile.error')}
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-background px-4 py-8">
      <div className="mx-auto mb-6 max-w-151.25">
        <h1 className="text-heading mb-6 text-xl font-semibold">{t('profile.title')}</h1>
        <ProfileCard user={user} />
      </div>
    </div>
  )
}
